export default __webpack_public_path__ + "static/media/Supabase-Logo.9f6561d6.svg";